

// import React from 'react';
// import './AttachmentsModal.css';

// const AttachmentsModal = ({ isOpen, onClose, files }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="modalOverlay">
//       <div className="modalContent">
//         <h2>Attachments</h2>
//         <button className="closeButton" onClick={onClose}>X</button>
//         <ul className="fileList">
//           {files.map((file, index) => (
//             <li key={index} className="fileItem">
//               {file?.mimeType?.startsWith('image/') ? (
//                 <img
//                   src={`data:${file.mimeType};base64,${file.base64Image}`}
//                   alt={file.filename}
//                   className="fileImage"
//                 />
//               ) : file.mimeType === 'application/pdf' ? (
//                 <iframe
//                   src={`data:${file.mimeType};base64,${file.base64Image}`}
//                   title={file.filename}
//                   className="filePdf"
//                 />
//               ) : (
//                 <a
//                   href={`data:${file.mimeType};base64,${file.base64Image}`}
//                   download={file.filename}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   title={`Download ${file.filename}`}
//                 >
//                   {file.filename}
//                 </a>
//               )}
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default AttachmentsModal;


import React from 'react';
import './AttachmentsModal.css';

const AttachmentsModal = ({ isOpen, onClose, files }) => {
  if (!isOpen) return null;

  return (
    <div className="modalOverlay">
      <div className="modalContent">
        <h2>Attachments</h2>
        <button className="closeButton" onClick={onClose}>X</button>
        <ul className="fileList">
          {files.map((file, index) => (
            <li key={index} className="fileItem">
              <a
                href={`data:${file.mimeType};base64,${file.base64Image}`}
                download={file.filename}
                target="_blank"
                rel="noopener noreferrer"
              >
                {file.filename}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AttachmentsModal;
